<template>
  <div class="bottom-bar-placeholder">
    <div class="bottom-bar flex">
      <div class="btn-item bg-FF" @click="goBack">
        {{ '返回' }}
      </div>
      <!--  保存   -->
      <!--      <div v-if="canSave()" class="btn-item bg-FF" @click="save">{{ '保存' }}</div>-->
      <!--  拒绝   -->
      <div v-if="submitInfo.canRefuse" class="btn-item bg-FF" @click="refuse">
        {{ submitInfo.refuseName || '拒绝' }}
      </div>
      <!--  重新发起  -->
      <div v-if="submitInfo.canResend && groupIdQuery()" class="btn-item bg-FFDB43" @click="resend">重新发起</div>
      <!--  同意  -->
      <div v-if="submitInfo.canHandle" class="btn-item bg-FFDB43" @click="agree">
        {{ submitInfo.agreeName || '同意' }}
      </div>
      <!--  发起   -->
      <div v-if="!processInstanceId" class="btn-item bg-FFDB43" @click="start">
        {{ submitInfo.agreeName || '发起' }}
      </div>
      <!--  更多   -->
      <div class="btn-item bg-FF">
        <el-dropdown trigger="click" style="width: 100%">
          <div>
            <span>更多</span>
            <i class="el-icon-more font-30 m-l-10"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="canSave()" @click.native="save()">保存</el-dropdown-item>
            <el-dropdown-item @click.native="comment">评论</el-dropdown-item>
            <!--  加签   -->
            <el-dropdown-item v-if="submitInfo.canAddMulti" @click.native="counterSign">
              {{ submitInfo.addMultiName || '加签' }}
            </el-dropdown-item>
            <!--  转办   -->
            <el-dropdown-item v-if="submitInfo.canAssignee" @click.native="assignee">
              {{ submitInfo.assigneeName || '转办' }}
            </el-dropdown-item>
            <!-- 撤销 -->
            <el-dropdown-item v-if="submitInfo.canRevoke" @click.native="revoke">
              {{ submitInfo.revokeName || '撤销' }}
            </el-dropdown-item>
            <!-- 撤回   -->
            <el-dropdown-item v-if="submitInfo.canReject" @click.native="reject">
              {{ submitInfo.rejectName || '撤回' }}
            </el-dropdown-item>
            <!-- 退回   -->
            <el-dropdown-item v-if="submitInfo.canBack" @click.native="onBack">
              {{ submitInfo.backName || '退回' }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <van-popup position="bottom" v-model="commentPopupShow">
      <div style="overflow-y: auto">
        <div class="p-20">
          <van-form :show-error="false" ref="commentForm">
            <van-field style="border: 2px solid #ccc" class="b-r-20" v-model="commentForm.comment" name="comment"
                       :rules="[{ required: true, message: '请输入评论' }]" type="textarea" maxlength="200" rows="3"
                       autosize show-word-limit placeholder="请输入评论"/>
            <span class="font-32">推荐回复:</span>
            <van-tag @click="addMentionComment(item)" plain class="m-l-10" v-for="(item,index) in replyList"
                     :key="index"
                     type="primary" size="medium">{{ item.dictLabel }}
            </van-tag>

            <van-field :value.prop="commentForm.attachments" name="attachments" placeholder="请上传附件">
              <template #input>
                <uploadFiles :files="commentForm.attachments" @success="uploadSuccess"
                             module-type="comment"></uploadFiles>
              </template>
            </van-field>
            <van-field :value.prop="commentForm.attachments" name="attachments" placeholder="提醒关注">
              <template #input>
                <van-button round block type="primary" @click="deptUserTreeAll.show = true">@提醒谁关注</van-button>
                <van-popup position="bottom" get-container="body" v-model="deptUserTreeAll.show">
                  <van-nav-bar title="选择人员" left-text="取消" right-text="确定"
                               @click-left="deptUserTreeAll.show = false" @click-right="commentPopupSubmit"/>
                  <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.tree)" clearable
                              shape="round"/>
                  <div style="overflow-y: auto" class="h-vh-50">
                    <div class="p-10">
                      <el-tree ref="tree" node-key="uuid" check-strictly :data="deptUserTreeAll.data"
                               :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                    </div>
                  </div>
                </van-popup>
              </template>
            </van-field>
            <div v-if="commentForm.userInfo.length > 0" style="display: flex;flex-wrap:wrap;margin-top: 15rpx;">
              <van-tag closeable v-for="(item,index) in commentForm.userInfo" type="warning" plain :key="index"
                       size="mini" class="m-l-10" closable
                       @close="closeUserInfo(item)">
                {{ item.label }}
              </van-tag>
            </div>
            <van-row :gutter="10" class="m-t-20">
              <van-col :span="12">
                <van-button native-type="button" @click="commentFormClose" block round>取消</van-button>
              </van-col>
              <van-col :span="12">
                <van-button native-type="button" @click.native="commentFormSubmit" block type="primary" round>提交
                </van-button>
              </van-col>
            </van-row>
          </van-form>
        </div>
      </div>
    </van-popup>
    <van-popup position="bottom" :close-on-click-overlay="false" v-model="submitFormShow">
      <div style="overflow-y: auto" class="p-20">
        <van-form ref="submitForm" :show-error="false">
          <van-field style="border: 2px solid #ccc" class="b-r-20" v-model="submitFormData.comments" name="comments"
                     :rules="[{ required: true, message: '请输入审批意见' }]" type="textarea" maxlength="200" rows="3"
                     autosize show-word-limit
                     :placeholder="submitType == 'assignee'  ? '请输入转办意见' : '请输入审批意见'"/>
          <span v-if="submitType !== 'assignee'" class="font-32">推荐回复:</span>
          <van-tag @click="addComment(item)" plain class="m-l-10" v-for="(item,index) in replyList" :key="index"
                   type="primary" size="medium">{{ item.dictLabel }}
          </van-tag>


          <van-field v-if="submitType == 'assignee'" :rules="[{required: true, message: '请选择转办人'}]"
                     :value="submitFormData.transferUserInfoStr" name="transferUserInfoStr" placeholder="转办">
            <template #input>
              <div class="flex-1" v-if="submitFormData.transferUserInfo">转办人：{{
                  submitFormData.transferUserInfo.label
                }}
              </div>
              <van-button class="flex-1" native-type="button" round block type="primary"
                          @click="deptUserTreeAll.show = true">{{
                  submitFormData.transferUserInfo ? '重新选择' : '选择转办人'
                }}
              </van-button>
              <van-popup position="bottom" get-container="body" v-model="deptUserTreeAll.show">
                <van-nav-bar title="选择人员" left-text="取消" right-text="确定"
                             @click-left="deptUserTreeAll.show = false"
                             @click-right="assigneePopupSubmit"/>
                <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.assigneeTree)"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-50">
                  <div class="p-10">
                    <el-tree ref="assigneeTree" node-key="uuid"
                             @check-change="approverCheckChange($event, $refs.assigneeTree)" check-strictly
                             :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>

          <van-row :gutter="10" class="m-t-20">
            <van-col :span="12">
              <van-button native-type="button" @click="submitFormCancel" block round>取消</van-button>
            </van-col>
            <van-col :span="12">
              <van-button native-type="button" @click.native="submitForm" block type="primary" round>提交</van-button>
            </van-col>
          </van-row>
        </van-form>
      </div>
    </van-popup>
    <van-popup position="bottom" :close-on-click-overlay="false" v-model="counterSignShow">
      <div style="overflow-y: auto" class="p-20 counterSign-container">
        <van-form error-message-align="right" ref="counterSignForm" :show-error="false">
          <van-field required style="border: 2px solid #ccc" class="b-r-20" v-model="counterSignForm.comments"
                     name="comments"
                     :rules="[{ required: true, message: '请输入意见' }]" type="textarea" maxlength="200" rows="3"
                     autosize show-word-limit placeholder="请输入加签意见"/>
          <div class="font-30 m-t-10" v-if="counterSignForm.multiAddUserInfo.length > 0">
            <span>加签人：</span>
            <van-tag type="primary" size="medium" class="m-l-5" v-for="(item,index) in counterSignForm.multiAddUserInfo"
                     :key="index"> {{ item.label || item.name }}
            </van-tag>
          </div>
          <van-field required name="multiAddUserInfo" placeholder="加签">
            <template #input>
              <van-button native-type="button" round block type="primary" @click="deptUserTreeAll.show = true">
                {{ counterSignForm.multiAddUserInfo.length > 0 ? '重新选择' : '选择加签人' }}
              </van-button>
              <van-popup position="bottom" get-container="body" v-model="deptUserTreeAll.show">
                <van-nav-bar title="选择人员" left-text="取消" right-text="确定"
                             @click-left="deptUserTreeAll.show = false"
                             @click-right="counterSignPopupSubmit"/>
                <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.counterSignTree)"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-50">
                  <div class="p-10">
                    <el-tree ref="counterSignTree" node-key="uuid" check-strictly :data="deptUserTreeAll.data"
                             :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
          <van-row :gutter="10" class="m-t-20">
            <van-col :span="12">
              <van-button native-type="button" @click="counterSignCancel" block round>取消</van-button>
            </van-col>
            <van-col :span="12">
              <van-button native-type="button" @click.native="counterSignSubmit" block type="primary" round>提交
              </van-button>
            </van-col>
          </van-row>
        </van-form>
      </div>

    </van-popup>
    <van-popup round v-model="relevanceFlowShow" style="width: 80%">
      <div class="p-l-20">
        <titleBar title="请选择关联流程"></titleBar>
        <div class="mt10">
          <van-grid :column-num="2">
            <van-grid-item v-for="(item,i) in userFlowList" :key="i" @click="userFlowChange(item)">
              <div class="avatar">{{ item.templateName.substring(0, 1) }}</div>
              <div class="first-title m-t-20">{{ item.templateName }}</div>
              <div class="second-title m-t-20">{{ item.remark }}</div>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import mixin from '@/mixin/flow'

import {getDictDataByType} from '@/api/dict.js';
import {mapState} from "vuex";
import {getUseFlows} from "@/api/flow";
import uploadFiles from "@/components/uploadFiles/index.vue";
import {getDeptUserTreeAll} from '@/api/user.js'
import titleBar from "@/components/title-bar.vue";

export default {
  name: 'BottomBar',
  components: {uploadFiles, titleBar},
  mixins: [mixin],
  watch: {
    submitInfo(val) {
      console.log('submitInfo ------', val)
      // console.log('是否在办理节点', val.canHandle)
      // console.log('是否输入意见', val.signFlag)
      // console.log('是否签名', val.showSign)
    }
  },
  data() {
    return {
      // 加签弹框
      counterSignShow: false,
      // 关联流程弹框
      relevanceFlowShow: false,
      // 用户关联的流程
      userFlowList: [],
      counterSignForm: {
        comments: '',
        multiAddUserInfo: []
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      submitFormShow: false,
      commentPopupShow: false,
      submitFormData: {
        comments: '',
        transferUserInfo: '',
        transferUserInfoStr: ''
      },
      commentForm: {
        instanceId: '',
        taskId: '',
        comment: '',
        attachments: [],
        userInfo: []
      },
      replyList: [],
      submitType: ''
    }
  },
  computed: {
    ...mapState({
      submitInfo: state => state.process.submitInfo,
      perms: state => state.process.perms,
      processInstanceId: state => state.process.processInstanceId
    })
  },
  created() {

  },
  mounted() {
  },
  methods: {
    counterSignCancel() {
      this.counterSignShow = false
      this.counterSignForm = {
        comments: '',
        multiAddUserInfo: []
      }
    },
    counterSignSubmit() {
      this.$refs.counterSignForm.validate().then(() => {
        if (this.counterSignForm.multiAddUserInfo.length === 0) {
          this.$message.error('请选择加签人')
          return
        }
        this.$emit('submit', {
          fn: 'counterSign',
          type: 'counterSign',
          text: '加签',
          comments: this.counterSignForm.comments,
          multiAddUserInfo: this.counterSignForm.multiAddUserInfo
        })
      })
    },
    goBack() {
      // 取出environmentType // 1:自建，2:三方
      const environmentType = this.$store.state.user.environmentType
      if (environmentType == '1') {
        // 自建环境
        if (this.$route.query.lastPage) {
          this.$router.push({
            path: this.$route.query.lastPage,
            query: {
              tabIndex: this.$route.query.lastPageTabIndex
            }
          })
        } else {
          this.$router.go(-1)
        }
      } else if (environmentType == '2') {
        // 三方环境
        this.$router.push('/homePage')
      }
    },
    closeUserInfo(item) {
      // 根据item.id 从列表中删除
      for (let i = 0; i < this.commentForm.userInfo.length; i++) {
        if (this.commentForm.userInfo[i].id === item.id) {
          this.commentForm.userInfo.splice(i, 1)
          break
        }
      }
    },

    assigneePopupSubmit() {
      const data = this.$refs.assigneeTree.getCheckedNodes()[0]
      this.submitFormData.transferUserInfo = data
      this.submitFormData.transferUserInfoStr = data.label
      this.deptUserTreeAll.show = false
    },
    counterSignPopupSubmit() {
      const data = this.$refs.counterSignTree.getCheckedNodes()
      this.counterSignForm.multiAddUserInfo = data
      console.log(this.counterSignForm)
      this.deptUserTreeAll.show = false
    },

    commentPopupSubmit() {
      const data = this.$refs.tree.getCheckedNodes()
      // 去重
      const existingUserIds = this.commentForm.userInfo.map(user => user.id);
      const uniqueData = data.filter(item => !existingUserIds.includes(item.id));
      this.commentForm.userInfo.push(...uniqueData)
      uniqueData.forEach(item => {
        this.commentForm.comment += ('@' + item.label)
      })
      this.deptUserTreeAll.show = false
    },
    commentFormClose() {
      this.commentPopupShow = false
      this.commentForm = {
        comment: '',
        userInfo: [],
        attachments: [],
        instanceId: '',
        taskId: ''
      }
    },
    commentFormSubmit() {
      this.$refs.commentForm.validate().then(() => {
        this.$emit('mention', this.commentForm, () => {
          this.commentFormClose()
        });
      })
    },
    submitFormCancel() {
      this.replyList = []
      this.submitFormShow = false
      this.submitFormData.comments = ''
    },
    submitForm() { // 负责处理需要填写审批意见的提交
      this.$refs.submitForm.validate().then(() => {
        if (this.submitType === 'agree') { // 同意
          this.agreeFlow()
        } else if ((this.submitType === 'refuse')) { // 拒绝
          this.$emit('submit', {fn: 'refuse', type: 'refuse', text: '拒绝', comments: this.submitFormData.comments})
        } else if ((this.submitType === 'onBack')) { // 退回
          this.$emit('submit', {fn: 'onBack', type: 'onBack', text: '退回', comments: this.submitFormData.comments})
        } else if (this.submitType === 'assignee') { // 转办
          this.$emit('submit', {
            fn: 'transmit',
            type: 'transmit',
            text: '转办',
            comments: this.submitFormData.comments,
            transferUserInfo: this.submitFormData.transferUserInfo
          })
        }
      })

    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.commentForm.attachments = fileList
    },
    addComment(value) {
      this.submitFormData.comments = this.submitFormData.comments + value.dictLabel;
    },
    addMentionComment(value) {
      this.commentForm.comment = this.commentForm.comment + value.dictLabel;
    },
    // 撤回
    reject() {
      this.$emit('submit', {fn: 'reject', type: 'reject', text: '撤回'})
    },
    // 重新发起
    resend() {
      this.$emit('submit', {fn: 'resend', type: 'resend', text: '重新发起'})
    },
    // 撤销
    revoke() {
      this.$emit('submit', {fn: 'revoke', type: 'revoke', text: '撤销'})
    },
    // 加签
    counterSign() {
      this.counterSignShow = true
      this.getDeptUserTreeAll()

    },
    // 同意
    agree() {
      if (this.submitInfo.signFlag || this.submitInfo.showSign) { // 需要签字或者填写意见时
        this.submitType = 'agree';
        this.submitFormShow = true
        this.getDictDataByType('recommand_answer').then(data => {
          this.replyList = data
        })
      } else {
        this.agreeFlow()
      }
    },
    userFlowChange(item) {
      const redirectQuery = {
        path: this.submitInfo.groupObject.appletStartReouter,
        query: {
          templateId: item.templateId,
          groupId: item.groupId,
          isRelevanceFlow: '1',
          destProcessInstanceId: this.processInstanceId
        }
      }
      this.$emit('submit', {fn: 'agree', type: 'agree', text: '同意', isRedirect: true, redirectQuery})
    },
    // 处理同意的操作，需要加最后关联流程的一步
    agreeFlow() {
      if (this.submitInfo?.canGoOther && this.submitInfo?.groupObject) {
        const groupId = this.submitInfo.groupObject.id
        getUseFlows({groupId}).then(res => {
          if (res.data.length > 1) {
            this.userFlowList = res.data
            this.relevanceFlowShow = true
          } else {
            const redirectQuery = {
              path: this.submitInfo.groupObject.appletStartReouter,
              query: {
                templateId: res.data[0].templateId,
                groupId: res.data[0].groupId,
                isRelevanceFlow: '1',
                destProcessInstanceId: this.processInstanceId
              }
            }
            this.$emit('submit', {
              fn: 'agree',
              type: 'agree',
              text: '同意',
              isRedirect: true,
              redirectQuery,
              comments: this.submitFormData.comments
            })
          }
        })
      } else {
        this.$emit('submit', {fn: 'agree', type: 'agree', text: '同意', comments: this.submitFormData.comments})
      }
    },
    groupIdQuery() {
      // 获取当前路由信息
      const currentRoute = this.$route;
      console.log('当前路由信息:', currentRoute);

      // 定义需要返回 false 的 groupId 列表
      const targetGroupIds = [20, 21, 22, 23, 24, 27, 29, 30];

      // 检查当前路由是否使用 process/view.vue 组件并且 groupId 在目标列表中
      if (currentRoute.meta && targetGroupIds.includes(currentRoute.meta.groupId)) {
        // 如果当前路由的 groupId 在目标列表中，返回 false
        return false;
      }
      // 其他情况返回 true
      return true;
    },
    // 发起流程
    start() {
      this.$emit('submit', {fn: 'start', type: 'start', text: '发起流程'})
    },
    // 拒绝
    refuse() {
      if (this.submitInfo.signFlag || this.submitInfo.showSign) { // 需要签字或者填写意见时
        this.submitType = 'refuse';
        this.submitFormShow = true
        this.getDictDataByType('refuse_answer').then(data => {
          this.replyList = data
        })
      } else {
        this.$emit('submit', {fn: 'refuse', type: 'refuse', text: '拒绝'})
      }
    },
    // 退回
    onBack() {
      if (this.submitInfo.signFlag || this.submitInfo.showSign) { // 需要签字或者填写意见时
        this.submitType = 'onBack';
        this.submitFormShow = true
        this.getDictDataByType('refuse_answer').then(data => {
          this.replyList = data
        })
      } else {
        this.$emit('submit', {fn: 'onBack', type: 'onBack', text: '退回'})
      }
    },
    // 转办
    assignee() {
      // 转办一定需要输入意见
      this.submitType = 'assignee';
      this.submitFormShow = true
      this.replyList = []
      this.getDeptUserTreeAll()
    },
    save() {
      this.$emit('submit', {
        fn: this.processInstanceId ? 'save' : 'start',
        type: 'save',
        text: '保存，有可能发起，有可能审批通过'
      })
    },
    canSave() {
      return this.perms.findIndex(item => item.perm == 'E') !== -1 && this.processData.businessStatusName !== '已结束'
    },

    setSubmitInfo(info) {
      this.submitInfo = info
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
        })
      })
    },
    comment() {
      this.getDeptUserTreeAll()
      this.getDictDataByType('comment_answer').then(data => {
        this.replyList = data
        this.commentPopupShow = true
      })
    },
    /**
     * 推荐意见内容
     * @param type
     * @returns {Promise<unknown>}
     */
    getDictDataByType(type) {
      return new Promise(resolve => {
        getDictDataByType(type).then(res => {
          if (res.code == 200) {
            resolve(res.data)
          }
        })
      })
    },

  }
}
</script>

<style scoped lang="less">
.avatar {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 50%;
  background: @theme-color;
  text-align: center;
  font-size: 44px;
}

.bottom-bar-placeholder {
  height: 110px;
}

.bottom-bar {
  position: fixed;
  background: #F7F7F7;
  height: 110px;
  line-height: 110px;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  z-index: 1000;
}

.btn-item {
  flex: 1;
  border: 1px solid #CCCCCC;
  height: 82px;
  line-height: 82px;
  border-radius: 10px;
  text-align: center;
  margin-left: 20px;
  font-size: 30px;
  color: #333;
  font-weight: 600;
}

.el-dropdown-menu {
  padding: 0 !important;
}

.el-dropdown-menu__item {
  height: 82px;
  line-height: 82px;
  color: #333;
  border-bottom: 1px solid #CCCCCC;
  padding: 0 110px;

}

.el-button, .el-dropdown {
  color: #333;
  font-size: 30px;
}


</style>
